module.exports = __webpack_public_path__ + "static/media/goods1_1.13186093.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/goods1_1.png
// module id = 1225
// module chunks = 0